<template>
    <main class="main" id="main">

        <div class="top_line">
            <div class="container">
                <h1>Личный кабинет - История</h1>
            </div>
        </div>

        <!----------Section LK------------->

        <section class="section s-lk">

            <div class="container">

                <div class="lk_box">

                    <navigate></navigate>

                    <div class="account_box">

                        <!--------POPUP----------->
                        <!--------POPUP----------->
                        <!--------POPUP----------->
                        <div class="info_popup" v-if="currentOrderId !== null">
                            <div class="info_header">
                                <h2>Информация о заказе</h2>
                                <button class="cross" @click="currentOrderId = null"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/cross.svg" alt=""></button>
                            </div>

                            <div class="info_inner">
                                <div class="info_row" v-if="currentOrder.name && currentOrder.name !== 'null'">
                                    <span class="key">Имя:</span>
                                    <p class="description">{{currentOrder.name}}</p>
                                </div>
                                <div class="info_row" v-if="currentOrder.email && currentOrder.email !== 'null'">
                                    <span class="key">E-mail:</span>
                                    <p class="description">{{currentOrder.email}}</p>
                                </div>
                                <div class="info_row" v-if="currentOrder.phone && currentOrder.phone !== 'null'">
                                    <span class="key">Тел. номер:</span>
                                    <p class="description">{{currentOrder.phone}}</p>
                                </div>
                                <div class="info_row" v-if="currentOrder.city && currentOrder.city !== 'null'">
                                    <span class="key">Город:</span>
                                    <p class="description">{{currentOrder.city}}</p>
                                </div>
                                <div class="info_row" v-if="currentOrder.street && currentOrder.street !== 'null'">
                                    <span class="key">Улица:</span>
                                    <p class="description">{{currentOrder.street}}</p>
                                </div>
                                <div class="info_row" v-if="currentOrder.house && currentOrder.house !== 'null'">
                                    <span class="key">Дом:</span>
                                    <p class="description">{{currentOrder.house}}</p>
                                </div>
                                <div class="info_row" v-if="currentOrder.floor && currentOrder.floor !== 'null'">
                                    <span class="key">Этаж:</span>
                                    <p class="description">{{currentOrder.floor}}</p>
                                </div>
                                <div class="info_row" v-if="currentOrder.room && currentOrder.room !== 'null'">
                                    <span class="key">Квартира:</span>
                                    <p class="description">{{currentOrder.room}}</p>
                                </div>
                                <div class="info_row" v-if="currentOrder.pay && currentOrder.pay !== 'null'">
                                    <span class="key">Тип оплаты:</span>
                                    <p class="description">{{currentOrder.pay}}</p>
                                </div>
                                <div class="info_row" v-if="currentOrder.when && currentOrder.when !== 'null'">
                                    <span class="key">Срок доставки:</span>
                                    <p class="description">{{currentOrder.when}}</p>
                                </div>
                            </div>

                            <div class="info_footer">
                                <div class="dish_item" v-for="(product, prodIndex) in currentOrder.products" :key="prodIndex">
                                    <div class="dish_row">
                                        <p class="dish_name">{{product.name}}</p>
                                        <span class="amount">{{product.quantity}} шт</span>
                                    </div>
                                    <span class="info_dish_price">{{product.price}} руб</span>
                                </div>

                                <div class="footer_totall">
                                    <p>Итого:</p>
                                    <span>{{currentOrder.amount}} руб</span>
                                </div>

                            </div>
                        </div>

                        <h1>Счета</h1>
                        <div class="chart_box">
                            <div class="chart_header">
                                <span @click="pay = 'bonus'" :class="pay === 'bonus' ? 'active':''">Бонусный счёт</span>
                                <span @click="pay = 'referral'" :class="pay === 'referral' ? 'active':''">Реферальный счёт</span>
                            </div>

                            <div class="chart_content" v-if="pay === 'bonus'">
                                <div class="bonus_box">
                                    <div class="account_earnings">
                                        <p>На Вашем счёте</p>
                                        <h2>{{user.bonus}} бонусных балла</h2>
                                    </div>

                                    <router-link tag="button" to="/present" class="menu_item_btn">ПОТРАТИТЬ БОНУСЫ</router-link>
                                    <router-link tag="button" to="/restaurants" class="menu_item_btn green">ЗАРАБОТАТЬ</router-link>
                                </div>

                                <div class="chart">
                                    <canvas class="chart" id="chart_profile" width="608" height="304"></canvas>
                                </div>
                            </div>
                            <div class="chart_content" v-else-if="pay === 'referral' && auth.users.promocode">
                                <div class="bonus_box">
                                    <div class="account_earnings">
                                        <p>Вы накопили</p>
                                        <h2>{{user.money}} рублей</h2>
                                    </div>

                                    <button class="menu_item_btn" @click="showModal('sendMoney')">ПЕРЕВЕСТИ БОНУСЫ</button>
                                </div>

                                <div class="chart">
                                    <canvas class="chart" id="chart_profile2" width="608" height="304"></canvas>
                                </div>
                            </div>
                            <div class="referal_box" v-else-if="pay === 'referral'">
                                <div class="earn_overlay">
                                    <h1>Прими участие в рефферальной программе.<br>
                                        Зарегистрируйся и зарабатывай вместе с нами!</h1>

                                    <router-link tag="button" to="/affiliate" class="menu_item_btn green">ЗАРАБОТАТЬ</router-link>
                                </div>
                            </div>
                        </div>

                        <div class="orders_box">

                            <table class="orders_table" id="orders_table">
                                <thead>
                                <tr class="orders_row active">
                                    <th>№</th>
                                    <th>Заказ №</th>
                                    <th>Поступил</th>
                                    <th>Статус</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>

                                <tr class="orders_row" v-for="(order, index) in orders" :key="index">
                                    <td>{{index + 1}}</td>
                                    <td>{{order.id}}</td>
                                    <td>{{order.date}}</td>
                                    <td>{{order.status}}</td>
                                    <td><button class="menu_item_btn" @click="currentOrderId = index">Подробнее</button></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>

            </div>
        </section>

    </main>

</template>

<script>
import navigate from '@/pages/lk/client/navigate'
import $ from 'jquery'
import Chart from 'chart.js'
import 'datatables'
import 'datatables/media/css/jquery.dataTables.css'
import axios from '@/router/http'
export default {
  name: 'index',
  props: ['city', 'auth', 'basket', 'geo', 'user'],
  data () {
    return {
      pay: null,
      orders: [],
      currentOrderId: null,
      currentOrder: {}
    }
  },
  components: {navigate},
  watch: {
    'currentOrderId' (val) {
      this.currentOrder = this.orders[val].order
    },
    orders () {
      setTimeout(() => {
        $('.orders_table').DataTable({
          'language': {
            'decimal': '',
            'emptyTable': 'No data available in table',
            'info': 'С _START_ до _END_ из _TOTAL_ записей',
            'infoEmpty': 'С 0 до 0 из 0 записей',
            'infoFiltered': '(filtered from _MAX_ total entries)',
            'infoPostFix': '',
            'thousands': ',',
            'lengthMenu': 'Выводить по _MENU_',
            'loadingRecords': 'Loading...',
            'processing': 'Processing...',
            'search': 'Искать:',
            'zeroRecords': 'No matching records found',
            'paginate': {
              'first': 'First',
              'last': 'Last',
              'next': 'След',
              'previous': 'Пред'
            },
            'aria': {
              'sortAscending': ': activate to sort column ascending',
              'sortDescending': ': activate to sort column descending'
            }
          }
        })
      }, 300)
    },
    pay (val) {
      if (val === 'bonus') {
        /* eslint-disable no-unused-vars */
        setTimeout(() => {
          axios.get('https://lk.when-hungry.com/mobile/get-bonuses?uid=' + this.auth.uid).then(response => {
            var ctx = document.getElementById('chart_profile').getContext('2d')
            var chart = new Chart(ctx, {
              type: 'line',
              data: {
                labels: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                datasets: [
                  {
                    label: 'Бонусы',
                    data: response.data,
                    backgroundColor: false,
                    pointBackgroundColor: 'rgba(0, 207, 0, 0.8)',
                    pointBorderColor: 'transparent',
                    borderColor: '#cfcfcf',
                    borderWidth: 2
                  }]
              },
              options: {
                barValueSpacing: 5,
                responsive: false,
                scales: {
                  xAxes: [{
                    ticks: {
                      top: 50,
                      fontSize: 14,
                      fontFamily: '"Open Sans", sans-serif'
                    }
                  }],
                  yAxes: [{
                    ticks: {
                      beginAtZero: true,
                      fontSize: 14,
                      fontFamily: '"Open Sans", sans-serif'
                    }
                  }]
                }
              }
            })
          })
        }, 300)

        /* eslint-enable no-unused-vars */
      } else {
        /* eslint-disable no-unused-vars */
        setTimeout(() => {
          axios.get('https://lk.when-hungry.com/mobile/get-moneys?uid=' + this.auth.uid).then(response => {
            var ctx = document.getElementById('chart_profile2').getContext('2d')
            var chart = new Chart(ctx, {
              type: 'line',
              data: {
                labels: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                datasets: [
                  {
                    label: 'Бонусы',
                    data: response.data,
                    backgroundColor: false,
                    pointBackgroundColor: 'rgba(0, 207, 0, 0.8)',
                    pointBorderColor: 'transparent',
                    borderColor: '#cfcfcf',
                    borderWidth: 2
                  }]
              },
              options: {
                barValueSpacing: 5,
                responsive: false,
                scales: {
                  xAxes: [{
                    ticks: {
                      top: 50,
                      fontSize: 14,
                      fontFamily: '"Open Sans", sans-serif'
                    }
                  }],
                  yAxes: [{
                    ticks: {
                      beginAtZero: true,
                      fontSize: 14,
                      fontFamily: '"Open Sans", sans-serif'
                    }
                  }]
                }
              }
            })
          })
        }, 300)

        /* eslint-enable no-unused-vars */
      }
    }
  },
  created () {
    this.pay = 'bonus'
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  },
  methods: {
    showModal (val) {
      this.$root.modals = val
    },
    initAjax () {
      axios.get('https://lk.when-hungry.com/mobile/get-orders?uid=' + this.auth.uid).then(response => {
        this.orders = response.data
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/client/index.vue